import PostsTableHelper from './post-table-helper';
import PostAttachmentsTableHelper from './post-attachments-table-helper';


const PostHelpers = {
    TableMain: PostsTableHelper,
    TableAttachments: PostAttachmentsTableHelper,
}

export default PostHelpers;